import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AssetProvider } from "./contexts/AssetListContext"; // Import context provider
import { UserProvider } from "./contexts/UserContext";
import { injectRiskCssVariables } from "./utils/riskConfig";
import Config from "./config.json";

import "./css/Values.css";
import "./css/App.css";

import Nav from "./components/Nav";
import CostAnalysis from "./components/CostAnalysis";
import DefectsPage from "./components/DefectsPage";
import Graphics from "./components/Graphics";
import InConstruction from "./components/InConstruction";
import PrivateRoute from "./components/PrivateRoute";

import Distribution from "./pages/Distribution";
import WorkspaceLayout from "./layouts/WorkspaceLayout";
import AssetDetails from "./pages/AssetDetails";
import DefectDetails from "./pages/DefectDetails";
import GetAnAccount from "./pages/GetAnAccount";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import SelectAppPage from "./pages/SelectAppPage";
import DigitalTwin from "./components/DigitalTwin";

function App() {
    // Inject risk colour CSS variables from config.json on first render
    useEffect(() => {
        injectRiskCssVariables();
    }, []);

    return (
        <div>
            <div className="App">
                <BrowserRouter>
                    <UserProvider>
                        <Nav />
                        <AssetProvider>
                            <Routes>
                                <Route path="/" element={<LoginPage />} />
                                <Route
                                    path="/get-account"
                                    element={<GetAnAccount />}
                                />
                                {Config.sites && Config.sites.length > 0 && (
                                    <Route
                                        path="/select-app"
                                        element={
                                            <PrivateRoute>
                                                <SelectAppPage />
                                            </PrivateRoute>
                                        }
                                    />
                                )}
                                <Route
                                    path="/landing"
                                    element={
                                        <PrivateRoute>
                                            <LandingPage />
                                        </PrivateRoute>
                                    }
                                />
                                <Route
                                    path="/digital-twin"
                                    element={
                                        <PrivateRoute>
                                            <DigitalTwin />
                                        </PrivateRoute>
                                    }
                                />
                                <Route
                                    path="/in-construction"
                                    element={
                                        <PrivateRoute>
                                            <InConstruction />
                                        </PrivateRoute>
                                    }
                                />
                                <Route
                                    path="/distribution"
                                    element={
                                        <PrivateRoute>
                                            <Distribution />
                                        </PrivateRoute>
                                    }
                                />
                                {/* Defects table + Cost analysis + Risk analysis (primary tabs) */}
                                <Route
                                    element={
                                        <PrivateRoute>
                                            <WorkspaceLayout />
                                        </PrivateRoute>
                                    }
                                >
                                    <Route
                                        path="/defects"
                                        element={<DefectsPage />}
                                    />
                                    <Route
                                        path="/analytics/cost-analysis"
                                        element={<CostAnalysis />}
                                    />
                                    <Route
                                        path="/analytics/risk-analysis"
                                        element={<Graphics />}
                                    />
                                </Route>
                                <Route
                                    path="/asset-details/:asset_id"
                                    element={
                                        <PrivateRoute>
                                            <AssetDetails />
                                        </PrivateRoute>
                                    }
                                />
                                <Route
                                    path="/defect-details/:defect_id"
                                    element={
                                        <PrivateRoute>
                                            <DefectDetails />
                                        </PrivateRoute>
                                    }
                                />
                                {/* Catch-all route to redirect to /landing */}
                                <Route
                                    path="*"
                                    element={<Navigate to="/landing" />}
                                />
                            </Routes>
                        </AssetProvider>
                    </UserProvider>
                </BrowserRouter>
            </div>
        </div>
    );
}

export default App;
